// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"a77b7378","237":"b746ef2d","298":"ba4fc7eb","519":"25ff9622","530":"6ba345fd","545":"c97d52e8","584":"b682e736","633":"dca04107","806":"246f939e","812":"8b1d1ef8","915":"df1e372a"}[chunkId] + ".chunk.js";
};